import { useAuth } from "../../auth/useAuth";
import { useMyNotices } from "../../lib/queries/notices";
import { NoticesView } from "./NoticesView";
import { ANSWERED_PREFIX, DISMISSED_PREFIX, useStoredIds } from "./useStoredIds";

/**
 * The signed-in user's popups, mounted once in `AppLayout`. Their lišty are
 * `NoticeStrip`, under each page's top bar.
 *
 * „Rozumím" is remembered by this browser, per account. Nothing on the
 * server reads who confirmed what, so it is not stored there; the cost is
 * that a popup confirmed on one device shows once more on another.
 *
 * While an admin impersonates somebody it is not remembered at all: the
 * popup is meant for the person, so the admin only puts it away for the
 * session.
 */
export function SignedInNotices() {
  const { user } = useAuth();
  const { data = [] } = useMyNotices();
  const answered = useStoredIds("local", `${ANSWERED_PREFIX}${user?.id ?? ""}`);
  const impersonating = !!user?.impersonator;
  const notices = data.filter((n) => n.display !== "popup" || !answered.ids.has(n.id));

  return (
    <NoticesView
      layout="app"
      banners={false}
      dismissKey={`${DISMISSED_PREFIX}${user?.id ?? ""}`}
      notices={notices}
      onAcknowledge={(id) => {
        if (!impersonating) answered.add(id);
      }}
    />
  );
}
